import React from 'react';
import {Modal, Row, Col} from 'react-bootstrap';
import label from '../../utils/lngEn';

const ConfirmDeleteModal = ({customTitle, customMsg, onConfirm, onCancel, showModal, confirmButtonTitle}) => {
    return (
      <Modal show={showModal} onHide={onCancel} backdrop="static" className="confirmModal">
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                {customTitle || label.deleteConfirmation}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mt-3 text-center font-size-20">{customMsg || 'Are you sure?'}</p>
        </Modal.Body>
        <Modal.Footer className="mt-3">
          <button onClick={onCancel} className="btn  btn-ter pull-left">Cancel</button>
          <button className="btn btn-primary pull-right" type="button" onClick={(e)=>{e.preventDefault(); onConfirm();}}>{confirmButtonTitle || 'Yes'}</button>
        </Modal.Footer>
      </Modal>
    );
  };

ConfirmDeleteModal.propTypes = {
  //myProp: PropTypes.string.isRequired
};

export default ConfirmDeleteModal;



// WEBPACK FOOTER //
// ./src/components/common/ConfirmDeleteModal.js